import { createSlice } from "@reduxjs/toolkit";
import { GetAllPatientList, GetPatientDetails } from "./PatientApi";


const defaultFilter = {
    branch_id: null,
    patient_name: "",
    patient_national_id: "",
    patient_mobile_no: "",
    patient_email: "",
    patient_mrn: "",
}

const initialState = {
    patientList: [],
    patientDetails: null,
    patientFilters: defaultFilter,
};

const patientSlice = createSlice({
    name: "patient",
    initialState,
    reducers: {
        handlePatientFilter: (state, action) => {
            state.patientFilters[action?.payload?.check] = action?.payload?.value;
        },
        handleResetPatientFilter: (state) => {
            state.patientFilters = defaultFilter;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAllPatientList.fulfilled, (state, { payload: { data } }) => {
                state.patientList = data;
            })
            .addCase(GetPatientDetails.fulfilled, (state, { payload: { data } }) => {
                state.patientDetails = data;
            })

    },
});

export const { handlePatientFilter, handleResetPatientFilter } = patientSlice.actions;

export default patientSlice.reducer;
